export default __webpack_public_path__ + "static/media/3d_card3.c573baa7.png";